"use strict";
// tslint:disable
/**
 * Sleekflow General Api
 * Sleekflow General Api
 *
 * The version of the OpenAPI document: api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhatsappCloudApiProductCatalogApi = void 0;
var runtime_1 = require("../runtime");
/**
 * no description
 */
var WhatsappCloudApiProductCatalogApi = /** @class */ (function (_super) {
    __extends(WhatsappCloudApiProductCatalogApi, _super);
    function WhatsappCloudApiProductCatalogApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WhatsappCloudApiProductCatalogApi.prototype.companyWhatsappCloudapiProductcatalogByWabaExchangeFacebookAuthorizationCodeGet = function (_a, opts) {
        var facebookAuthorizationCode = _a.facebookAuthorizationCode;
        (0, runtime_1.throwIfNullOrUndefined)(facebookAuthorizationCode, 'facebookAuthorizationCode', 'companyWhatsappCloudapiProductcatalogByWabaExchangeFacebookAuthorizationCodeGet');
        var headers = {};
        var query = {
            'facebookAuthorizationCode': facebookAuthorizationCode,
        };
        return this.request({
            url: '/company/whatsapp/cloudapi/productcatalog/by-waba/exchange-facebook-authorization-code',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    WhatsappCloudApiProductCatalogApi.prototype.companyWhatsappCloudapiProductcatalogByWabaGet = function (_a, opts) {
        var userAccessToken = _a.userAccessToken;
        (0, runtime_1.throwIfNullOrUndefined)(userAccessToken, 'userAccessToken', 'companyWhatsappCloudapiProductcatalogByWabaGet');
        var headers = {};
        var query = {
            'userAccessToken': userAccessToken,
        };
        return this.request({
            url: '/company/whatsapp/cloudapi/productcatalog/by-waba',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    WhatsappCloudApiProductCatalogApi.prototype.companyWhatsappCloudapiProductcatalogConnectFacebookWabasProductCatalogsPost = function (_a, opts) {
        var travisBackendDataWhatsappCloudApiConnectFacebookWabasProductCatalogsRequest = _a.travisBackendDataWhatsappCloudApiConnectFacebookWabasProductCatalogsRequest;
        (0, runtime_1.throwIfNullOrUndefined)(travisBackendDataWhatsappCloudApiConnectFacebookWabasProductCatalogsRequest, 'travisBackendDataWhatsappCloudApiConnectFacebookWabasProductCatalogsRequest', 'companyWhatsappCloudapiProductcatalogConnectFacebookWabasProductCatalogsPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/company/whatsapp/cloudapi/productcatalog/connect/facebook-wabas-product-catalogs',
            method: 'POST',
            headers: headers,
            body: travisBackendDataWhatsappCloudApiConnectFacebookWabasProductCatalogsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    WhatsappCloudApiProductCatalogApi.prototype.companyWhatsappCloudapiProductcatalogConnectedChannelsGet = function (_a, opts) {
        var allowCache = _a.allowCache;
        (0, runtime_1.throwIfNullOrUndefined)(allowCache, 'allowCache', 'companyWhatsappCloudapiProductcatalogConnectedChannelsGet');
        var headers = {};
        var query = {
            'allowCache': allowCache,
        };
        return this.request({
            url: '/company/whatsapp/cloudapi/productcatalog/connected-channels',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    WhatsappCloudApiProductCatalogApi.prototype.companyWhatsappCloudapiProductcatalogDisconnectDelete = function (_a, opts) {
        var travisBackendDataWhatsappCloudApiDisconnectWabaConnectedFacebookProductCatalogRequest = _a.travisBackendDataWhatsappCloudApiDisconnectWabaConnectedFacebookProductCatalogRequest;
        (0, runtime_1.throwIfNullOrUndefined)(travisBackendDataWhatsappCloudApiDisconnectWabaConnectedFacebookProductCatalogRequest, 'travisBackendDataWhatsappCloudApiDisconnectWabaConnectedFacebookProductCatalogRequest', 'companyWhatsappCloudapiProductcatalogDisconnectDelete');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/company/whatsapp/cloudapi/productcatalog/disconnect',
            method: 'DELETE',
            headers: headers,
            body: travisBackendDataWhatsappCloudApiDisconnectWabaConnectedFacebookProductCatalogRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    WhatsappCloudApiProductCatalogApi.prototype.companyWhatsappCloudapiProductcatalogPhoneNumberAutoSendPaymentUrlTogglePost = function (_a, opts) {
        var travisBackendDataWhatsappCloudApiUpdatePhoneNumberAutoSendStripePaymentLinkSettingRequest = _a.travisBackendDataWhatsappCloudApiUpdatePhoneNumberAutoSendStripePaymentLinkSettingRequest;
        (0, runtime_1.throwIfNullOrUndefined)(travisBackendDataWhatsappCloudApiUpdatePhoneNumberAutoSendStripePaymentLinkSettingRequest, 'travisBackendDataWhatsappCloudApiUpdatePhoneNumberAutoSendStripePaymentLinkSettingRequest', 'companyWhatsappCloudapiProductcatalogPhoneNumberAutoSendPaymentUrlTogglePost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/company/whatsapp/cloudapi/productcatalog/phone-number/auto-send-payment-url/toggle',
            method: 'POST',
            headers: headers,
            body: travisBackendDataWhatsappCloudApiUpdatePhoneNumberAutoSendStripePaymentLinkSettingRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    WhatsappCloudApiProductCatalogApi.prototype.companyWhatsappCloudapiProductcatalogPhoneNumberSettingsGet = function (_a, opts) {
        var wabaId = _a.wabaId, wabaPhoneNumberId = _a.wabaPhoneNumberId, allowCache = _a.allowCache;
        (0, runtime_1.throwIfNullOrUndefined)(wabaId, 'wabaId', 'companyWhatsappCloudapiProductcatalogPhoneNumberSettingsGet');
        (0, runtime_1.throwIfNullOrUndefined)(wabaPhoneNumberId, 'wabaPhoneNumberId', 'companyWhatsappCloudapiProductcatalogPhoneNumberSettingsGet');
        (0, runtime_1.throwIfNullOrUndefined)(allowCache, 'allowCache', 'companyWhatsappCloudapiProductcatalogPhoneNumberSettingsGet');
        var headers = {};
        var query = {
            'wabaId': wabaId,
            'wabaPhoneNumberId': wabaPhoneNumberId,
            'allowCache': allowCache,
        };
        return this.request({
            url: '/company/whatsapp/cloudapi/productcatalog/phone-number/settings',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    WhatsappCloudApiProductCatalogApi.prototype.companyWhatsappCloudapiProductcatalogPhoneNumberSettingsPost = function (_a, opts) {
        var travisBackendDataWhatsappCloudApiUpdateWabaProductCatalogPhoneNumbersCommerceSettingsRequest = _a.travisBackendDataWhatsappCloudApiUpdateWabaProductCatalogPhoneNumbersCommerceSettingsRequest;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/company/whatsapp/cloudapi/productcatalog/phone-number/settings',
            method: 'POST',
            headers: headers,
            body: travisBackendDataWhatsappCloudApiUpdateWabaProductCatalogPhoneNumbersCommerceSettingsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    WhatsappCloudApiProductCatalogApi.prototype.companyWhatsappCloudapiProductcatalogPhoneNumbersSettingsGet = function (_a, opts) {
        var wabaId = _a.wabaId, wabaPhoneNumberId = _a.wabaPhoneNumberId, allowCache = _a.allowCache;
        (0, runtime_1.throwIfNullOrUndefined)(wabaId, 'wabaId', 'companyWhatsappCloudapiProductcatalogPhoneNumbersSettingsGet');
        (0, runtime_1.throwIfNullOrUndefined)(wabaPhoneNumberId, 'wabaPhoneNumberId', 'companyWhatsappCloudapiProductcatalogPhoneNumbersSettingsGet');
        (0, runtime_1.throwIfNullOrUndefined)(allowCache, 'allowCache', 'companyWhatsappCloudapiProductcatalogPhoneNumbersSettingsGet');
        var headers = {};
        var query = {
            'wabaId': wabaId,
            'wabaPhoneNumberId': wabaPhoneNumberId,
            'allowCache': allowCache,
        };
        return this.request({
            url: '/company/whatsapp/cloudapi/productcatalog/phone-numbers/settings',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    WhatsappCloudApiProductCatalogApi.prototype.companyWhatsappCloudapiProductcatalogProductItemGet = function (_a, opts) {
        var wabaId = _a.wabaId, productRetailerId = _a.productRetailerId, allowCache = _a.allowCache;
        (0, runtime_1.throwIfNullOrUndefined)(wabaId, 'wabaId', 'companyWhatsappCloudapiProductcatalogProductItemGet');
        (0, runtime_1.throwIfNullOrUndefined)(productRetailerId, 'productRetailerId', 'companyWhatsappCloudapiProductcatalogProductItemGet');
        (0, runtime_1.throwIfNullOrUndefined)(allowCache, 'allowCache', 'companyWhatsappCloudapiProductcatalogProductItemGet');
        var headers = {};
        var query = {
            'wabaId': wabaId,
            'productRetailerId': productRetailerId,
            'allowCache': allowCache,
        };
        return this.request({
            url: '/company/whatsapp/cloudapi/productcatalog/product-item',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    WhatsappCloudApiProductCatalogApi.prototype.companyWhatsappCloudapiProductcatalogProductItemsGet = function (_a, opts) {
        var wabaId = _a.wabaId, allowCache = _a.allowCache;
        (0, runtime_1.throwIfNullOrUndefined)(wabaId, 'wabaId', 'companyWhatsappCloudapiProductcatalogProductItemsGet');
        (0, runtime_1.throwIfNullOrUndefined)(allowCache, 'allowCache', 'companyWhatsappCloudapiProductcatalogProductItemsGet');
        var headers = {};
        var query = {
            'wabaId': wabaId,
            'allowCache': allowCache,
        };
        return this.request({
            url: '/company/whatsapp/cloudapi/productcatalog/product-items',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    WhatsappCloudApiProductCatalogApi.prototype.companyWhatsappCloudapiProductcatalogUpdatePost = function (_a, opts) {
        var travisBackendDataWhatsappCloudApiUpdateWabaConnectedFacebookProductCatalogRequest = _a.travisBackendDataWhatsappCloudApiUpdateWabaConnectedFacebookProductCatalogRequest;
        (0, runtime_1.throwIfNullOrUndefined)(travisBackendDataWhatsappCloudApiUpdateWabaConnectedFacebookProductCatalogRequest, 'travisBackendDataWhatsappCloudApiUpdateWabaConnectedFacebookProductCatalogRequest', 'companyWhatsappCloudapiProductcatalogUpdatePost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/company/whatsapp/cloudapi/productcatalog/update',
            method: 'POST',
            headers: headers,
            body: travisBackendDataWhatsappCloudApiUpdateWabaConnectedFacebookProductCatalogRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    return WhatsappCloudApiProductCatalogApi;
}(runtime_1.BaseAPI));
exports.WhatsappCloudApiProductCatalogApi = WhatsappCloudApiProductCatalogApi;
